<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)"
     (pointercancel)="onPointerUp($event)"
     (pointerleave)="onPointerUp($event)">

  <defs>
    <radialGradient id="mu-panel" cx="50%" cy="35%" r="85%">
      <stop offset="0%" stop-color="#3a2a6b" />
      <stop offset="55%" stop-color="#241a4d" />
      <stop offset="100%" stop-color="#160f33" />
    </radialGradient>
    <linearGradient id="mu-tile" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#8ad4ff" />
      <stop offset="50%" stop-color="#a97bff" />
      <stop offset="100%" stop-color="#ff8fd0" />
    </linearGradient>
    <linearGradient id="mu-tile-placed" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#fff2b0" />
      <stop offset="100%" stop-color="#ffbf57" />
    </linearGradient>
    <filter id="mu-glow" x="-40%" y="-40%" width="180%" height="180%">
      <feGaussianBlur stdDeviation="6" result="b" />
      <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
    </filter>
  </defs>

  <!-- Panel -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0"
        fill="url(#mu-panel)" stroke="rgba(255,255,255,0.14)" stroke-width="2" />

  <!-- Starfield -->
  <g fill="#ffffff">
    <circle cx="120" cy="80" r="2" opacity="0.5" />
    <circle cx="340" cy="55" r="1.6" opacity="0.35" />
    <circle cx="560" cy="95" r="2.2" opacity="0.55" />
    <circle cx="820" cy="70" r="1.5" opacity="0.4" />
    <circle cx="930" cy="150" r="2" opacity="0.5" />
    <circle cx="70" cy="330" r="1.6" opacity="0.4" />
    <circle cx="960" cy="360" r="1.8" opacity="0.45" />
  </g>

  <!-- Target slots -->
  <g *ngFor="let s of slots" class="slot" [class.filled]="s.filled"
     [attr.transform]="'translate(' + s.pos.x + ',' + s.pos.y + ')'">
    <rect class="slot-box" [attr.x]="-SLOT/2" [attr.y]="-SLOT/2" [attr.width]="SLOT" [attr.height]="SLOT" rx="22" />
    <ng-container *ngIf="!s.filled">
      <!-- dots (count) + dice: both are pips, different arrangement -->
      <circle *ngFor="let p of s.pips" class="pip" [attr.cx]="p.x" [attr.cy]="p.y" r="11" />

      <!-- ten-frame -->
      <g *ngIf="s.pair.slotKind === 'tenframe'">
        <g *ngFor="let cell of s.cells">
          <rect class="tf-cell" [attr.x]="cell.x - 11" [attr.y]="cell.y - 11" width="22" height="22" rx="5" />
          <circle *ngIf="cell.on" class="tf-dot" [attr.cx]="cell.x" [attr.cy]="cell.y" r="7.5" />
        </g>
      </g>

      <!-- expression (add / sub) -->
      <text *ngIf="s.pair.slotKind === 'expr'" class="slot-expr" x="0" y="0"
            text-anchor="middle" dominant-baseline="central">{{ s.exprText }}</text>
    </ng-container>
  </g>

  <!-- Sparkles -->
  <g class="sparkles">
    <circle *ngFor="let sp of sparkles" class="sparkle"
            [attr.cx]="sp.x" [attr.cy]="sp.y" [attr.r]="sp.r"
            [style.animation-delay.ms]="sp.delay" fill="#fff4b0" />
  </g>

  <!-- Draggable tiles -->
  <g *ngFor="let t of tiles" class="tile" [class.dragging]="t.dragging" [class.placed]="t.placed"
     [attr.transform]="'translate(' + t.pos.x + ',' + t.pos.y + ')'"
     (pointerdown)="onTileDown(tiles.indexOf(t), $event)">
    <rect class="tile-box" [attr.x]="-TILE/2" [attr.y]="-TILE/2" [attr.width]="TILE" [attr.height]="TILE" rx="20"
          [attr.fill]="t.placed ? 'url(#mu-tile-placed)' : 'url(#mu-tile)'"
          filter="url(#mu-glow)" />
    <text class="tile-glyph" x="0" y="0" text-anchor="middle" dominant-baseline="central">{{ t.pair.tileText }}</text>
  </g>
</svg>
